import { Component } from '@opten/compiler/metadata/component';
import mixitup from 'mixitup'; // loaded from node_modules

@Component({ className: 'js-mixitup' })
export class MixitupComponent {
	private filterTargetClass: string;
	private filterTargets: Element[];
	constructor(private element: HTMLElement) {
		this.filterTargetClass = element.getAttribute('data-filter-target-class');

		this.filterTargets = Array.from(document.getElementsByClassName(this.filterTargetClass));
		const firstElementClass = this.filterTargets[0].getAttribute('data-class');
		mixitup(element, {
			selectors: {
				target: '.' + this.filterTargetClass,
				control: '.js-mixitup-control'
			},
			animation: {
				duration: 30
			},
			load: {
				filter: '.' + firstElementClass
			}
		});
	}
}

@Component({ className: 'js-mixitup-search' })
export class MixitupSearchComponent {
	private mixer: any;
	private filterTargetClass: string;
	private filterTargets: Element[];
	private inputSearch;
	private keyupTimeout;
	private searchValue: string;

	constructor(private element: HTMLElement) {
		this.filterTargetClass = element.getAttribute('data-filter-target-class');
		this.filterTargets = Array.from(document.getElementsByClassName(this.filterTargetClass));
		this.inputSearch = element.querySelector('[data-ref="input-search"]');
		this.searchValue = '';
		this.mixer = mixitup(element, {
			selectors: {
				target: '.' + this.filterTargetClass
			},
			animation: {
				duration: 300
			},
			controls: {
				enable: false,
				scope: 'local'
			},
			callbacks: {
				onMixEnd: () => {
					if (this.searchValue.length > 3 && !this.mixer.getState().totalMatching) {
						this.mixer.filter('.js-no-results');
					} else if (!this.mixer.getState().totalMatching) {
						this.mixer.filter('.js-default-search');
					}
				}
			}
		});

		this.inputSearch.addEventListener('keyup', () => {
			if (this.inputSearch.value.length < 4) {
				// If the input value is less than 4 characters, don't send
				this.searchValue = '';
			} else {
				this.searchValue = this.inputSearch.value.toLowerCase().trim();
			}

			// Very basic throttling to prevent mixer thrashing. Only search
			// once 350ms has passed since the last keyup event

			clearTimeout(this.keyupTimeout);

			this.keyupTimeout = setTimeout(() => {
				this.filterByString(this.searchValue);
			}, 350);
		});
	}

	private filterByString(searchValue) {
		if (searchValue) {
			// Use an attribute wildcard selector to check for matches
			this.mixer.filter('[class*="' + searchValue + '"]');
		} else {
			// If no searchValue, treat as filter('all')

			this.mixer.filter('.js-default-search');
		}
	}
}
